import { graphql } from '@apollo/client/react/hoc';
import * as React from 'react';
import idx from 'idx';
import pluralize from 'pluralize';

import CenteredLoadingIndicator from 'components/CenteredLoadingIndicator';
import BoxBody from 'components/BoxBody';
import Dialog from 'components/Dialog';
import Divider from 'components/Divider';
import Emoji from 'components/Emoji';
import ErrorReporter from 'app/components/ErrorReporter';
import EventTracking from 'lib/EventTracking';
import Heading from 'components/Heading';
import List from 'components/List';
import ListItem from 'components/ListItem';
import MediaObject from 'components/MediaObject';
import reactionSettings from 'user/queries/reactionSettings.gql';
import Row from 'components/Row';
import ScrollContainer from 'components/ScrollContainer';
import Text from 'components/Text';
import UserAvatar from 'users/components/UserAvatar';

type Props = {
  // @ts-expect-error ts-migrate(2304) FIXME: Cannot find name 'ReactionGQL'.
  reactions: ReactionGQL[];
  reactionInventory?: Map<string, string>;
  onRequestHide: () => void;
};

class ReactionSummaryModal extends React.Component<Props, {}> {
  componentDidMount() {
    EventTracking.trackKey('reaction_summary.view');
  }

  renderReactionSection(name: string, count: number | undefined | null, users: any) {
    const { reactionInventory } = this.props;
    if (!reactionInventory) {
      return <CenteredLoadingIndicator />;
    }

    const unicodeChar = reactionInventory.get(name);
    if (!unicodeChar) {
      return (
        <ErrorReporter error="ReactionSummaryModal - Tried to render reaction section without a matching unicodeChar" />
      );
    }

    if (!count) {
      return null;
    }

    return (
      <Row size="small">
        <Text align="left">
          <Heading level="3" divided>
            {count} {pluralize('person', count)} reacted with <Emoji character={unicodeChar} />
          </Heading>
          <List indented>
            {/* @ts-expect-error ts-migrate(7006) FIXME: Parameter 'user' implicitly has an 'any' type. */}
            {users.map((user) => (
              <ListItem key={user.uuid}>
                <MediaObject gutter="small" center>
                  <UserAvatar size="medium" user={user} />
                  <Text>{user.name}</Text>
                </MediaObject>
                <Divider size="xxsmall" />
              </ListItem>
            ))}
          </List>
        </Text>
      </Row>
    );
  }

  render() {
    const { reactions } = this.props;
    return (
      <Dialog
        title="Reactions summary"
        subtext={`${reactions.length} ${pluralize('reaction', reactions.length)} total`}
        size="small"
        onRequestHide={this.props.onRequestHide}
        data-test="reaction-summary-dialog"
      >
        <BoxBody>
          <ScrollContainer maxHeight={400}>
            {reactions.map((reaction) =>
              this.renderReactionSection(reaction.name, reaction.count, reaction.users)
            )}
          </ScrollContainer>
        </BoxBody>
      </Dialog>
    );
  }
}

const withReactions = graphql(reactionSettings, {
  props: ({ data }) => {
    // @ts-expect-error ts-migrate(2532) FIXME: Object is possibly 'undefined'.
    const reactions = idx(data, (_) => _.settings.reactionInventory.reactions);
    if (!reactions) {
      return new Map();
    }

    return {
      // @ts-expect-error ts-migrate(7006) FIXME: Parameter 'r' implicitly has an 'any' type.
      reactionInventory: new Map(reactions.map((r) => [r.name, r.unicode])),
    };
  },
});

export { ReactionSummaryModal };

// @ts-expect-error ts-migrate(2345) FIXME: Argument of type 'typeof ReactionSummaryModal' is ... Remove this comment to see the full error message
export default withReactions(ReactionSummaryModal);
